/**
 * CARVAZ E-commerce Scripts v3.0
 * Funcionalidad principal del tema
 */

// ============================================
// STICKY HEADER (con null check)
// ============================================
const initStickyHeader = () => {
  const header = document.querySelector('.header-main');
  if (!header) return;

  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }

    lastScroll = currentScroll;
  }, { passive: true });
};

// ============================================
// CART FUNCTIONS
// ============================================
async function updateQuantity(key, quantity) {
  quantity = parseInt(quantity);
  if (isNaN(quantity) || quantity < 0) return;
  if (quantity === 0) return removeItem(key);

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });

    if (!response.ok) throw new Error('Error updating cart');

    const cart = await response.json();
    updateCartUI(cart);

  } catch (error) {
    console.error('Error:', error);
    if (window.showNotification) {
      window.showNotification('Error al actualizar', 'error');
    }
  }
}

async function removeItem(key) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });

    if (!response.ok) throw new Error('Error removing item');

    const cart = await response.json();
    updateCartUI(cart);

    // Remove item from DOM with animation
    const itemEl = document.querySelector(`[data-item-key="${key}"]`);
    if (itemEl) {
      itemEl.style.opacity = '0';
      itemEl.style.transform = 'translateX(20px)';
      setTimeout(() => itemEl.remove(), 300);
    }

    if (window.showNotification) {
      window.showNotification('Producto eliminado', 'info');
    }

  } catch (error) {
    console.error('Error:', error);
    if (window.showNotification) {
      window.showNotification('Error al eliminar', 'error');
    }
  }
}

function updateCartUI(cart) {
  // Update cart count badges
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = cart.item_count;
    if (cart.item_count > 0) {
      el.classList.remove('hidden');
    } else {
      el.classList.add('hidden');
    }
  });

  // Update subtotal
  const subtotalEl = document.querySelector('.cart-subtotal-value');
  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(cart.total_price);
  }

  // Update free shipping bar
  updateFreeShippingBar(cart.total_price);

  // If cart is empty, show empty state
  if (cart.item_count === 0) {
    const itemsContainer = document.getElementById('cart-drawer-items');
    if (itemsContainer) {
      itemsContainer.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty-icon">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
            </svg>
          </div>
          <h3>Tu carrito esta vacio</h3>
          <p>Descubre nuestros productos increibles</p>
          <a href="/collections/all" class="cart-empty-btn" onclick="toggleCartDrawer()">
            Explorar Productos
          </a>
        </div>
      `;
    }
  }
}

function updateFreeShippingBar(cartTotal) {
  const threshold = 500000 * 100; // 500,000 Gs en centavos
  const remaining = threshold - cartTotal;
  const progress = Math.min((cartTotal / threshold) * 100, 100);

  const progressFill = document.querySelector('.shipping-progress-fill');
  const shippingBar = document.querySelector('.free-shipping-bar');
  const shippingText = document.querySelector('.shipping-text');

  if (progressFill) {
    progressFill.style.width = progress + '%';
  }

  if (shippingBar && shippingText) {
    if (remaining <= 0) {
      shippingBar.classList.add('shipping-complete');
      shippingText.innerHTML = '<svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="display:inline;vertical-align:middle;margin-right:6px"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg><strong>Envio gratis desbloqueado</strong>';
    } else {
      shippingBar.classList.remove('shipping-complete');
      shippingText.innerHTML = 'Agrega <strong>' + formatMoney(remaining) + '</strong> mas para envio gratis';
    }
  }
}

function formatMoney(cents) {
  return new Intl.NumberFormat('es-PY', {
    style: 'currency',
    currency: 'PYG',
    minimumFractionDigits: 0
  }).format(cents / 100);
}


window.showNotification = function (message, type = 'info') {
  // Remove existing notification
  const existing = document.querySelector('.notification-toast');
  if (existing) existing.remove();

  const notification = document.createElement('div');
  notification.className = 'notification-toast';
  notification.style.cssText = `
    position: fixed;
    bottom: 24px;
    right: 24px;
    padding: 16px 24px;
    background: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#0055A4'};
    color: white;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    z-index: 9999;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 10px;
    animation: slideIn 0.3s ease;
  `;

  const icon = type === 'success' ?
    '<svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>' :
    type === 'error' ?
      '<svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>' :
      '<svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>';

  notification.innerHTML = icon + message;
  document.body.appendChild(notification);

  // Add animation keyframes if not exists
  if (!document.querySelector('#notification-styles')) {
    const style = document.createElement('style');
    style.id = 'notification-styles';
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }

  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease forwards';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
};


document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();

  // Close cart on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.classList.contains('active')) {
        toggleCartDrawer();
      }
    }
  });
});
